const content = {
  title: "Palvelumme",
  body: "Tarjoamme kattavat perusterveydenhoitopalvelut koirille, kissoille ja muille pieneläimille.",
  hero: {
    title: "Palvelumme",
    subtitle: "",
  },
  meta: {
    title: "Palvelumme | Eläinlääkäriasema Sinni",
    description:
      "Palvelemme sinua ammattitaidolla kaikkiin lemmikkisi hoitoon liittyvissä asioissa.",
  },
  seePrices: "Katso hinnasto",
};

export default content;
